import type { FC, ReactNode } from 'react';
import { useSwipeable } from 'react-swipeable';

type Props = {
  onSwipedLeft?(): void;
  onSwipedRight?(): void;
  children: ReactNode;
  className?: string;
};

export const Swipe: FC<Props> = ({ onSwipedLeft, onSwipedRight, children, className }) => {
  const handlers = useSwipeable({
    onSwipedLeft,
    onSwipedRight,
  });

  return (
    <div className={className} {...handlers}>
      {children}
    </div>
  );
};

Swipe.defaultProps = {
  className: '',
  onSwipedLeft: () => null,
  onSwipedRight: () => null,
};
